(() => {
  if (window.adelaisXOAutoplay) return;
  window.adelaisXOAutoplay = true;
  const tracked = new Map();
  function play(video, state) {
    if (!state.visible || document.hidden || state.pending) return;
    state.pending = true;
    video.play().then(() => {
      state.button.hidden = true;
      if (!state.visible || document.hidden) video.pause();
    }).catch(() => { state.button.hidden = !state.visible; }).finally(() => { state.pending = false; });
  }
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    const state = tracked.get(entry.target);
    if (!state) return;
    state.visible = entry.isIntersecting && entry.intersectionRatio >= .15;
    if (state.visible) play(entry.target, state);
    else { entry.target.pause(); state.button.hidden = true; }
  }), {threshold:[0,.15]});
  function scan() {
    for (const [video, state] of tracked) if (!video.isConnected) {
      observer.unobserve(video); state.button.remove(); tracked.delete(video);
    }
    document.querySelectorAll('.xo-gallery video').forEach(video => {
      if (tracked.has(video)) return;
      video.muted = true; video.defaultMuted = true; video.playsInline = true;
      video.setAttribute('muted',''); video.setAttribute('playsinline','');
      video.removeAttribute('autoplay'); video.preload = 'metadata'; video.pause();
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = '▶ Play video'; button.hidden = true;
      button.style.cssText = 'position:absolute;bottom:16px;left:50%;transform:translateX(-50%);z-index:5;min-height:44px;padding:8px 16px;background:#3f503b;color:#f7f5f0;border:0;border-radius:4px;cursor:pointer';
      const holder = video.parentElement; holder.style.position = 'relative'; holder.append(button);
      const state = {visible:false,pending:false,button}; tracked.set(video,state);
      button.addEventListener('click',()=>play(video,state));
      video.addEventListener('loadeddata',()=>play(video,state));
      observer.observe(video);
    });
  }
  let queued = false;
  new MutationObserver(() => {
    if (queued) return; queued = true;
    requestAnimationFrame(()=>{queued=false;scan();});
  }).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('visibilitychange',()=>tracked.forEach((state,video)=>{
    if(document.hidden)video.pause();else play(video,state);
  }));
  scan();
})();
